import { z, tenantSlugSchema } from '@kc3/validation';
export const LoginRequestSchema = z.object({
    tenantSlug: tenantSlugSchema.optional(),
    email: z.string().email().optional(),
    loginId: z.string().min(1).optional(),
    password: z.string().min(8),
}).refine((data) => data.email || data.loginId, {
    message: 'Either email or loginId is required',
    path: ['email'],
});
// Two response shapes (zod discriminated union via .or):
//   { accessToken } — full auth issued (refresh token rides in HttpOnly cookie, NOT in body)
//   { requiresMfa: true, preAuthToken } — MFA challenge required, redeem at POST /auth/mfa/verify-login
// Field names match @kc3/auth.PreAuthTokenPayload + apps/api/src/routes/auth/login.ts.
export const LoginResponseSchema = z.union([
    z.object({
        accessToken: z.string().min(1),
        requiresMfa: z.literal(false).optional(),
    }),
    z.object({
        requiresMfa: z.literal(true),
        preAuthToken: z.string().min(1),
        setupRequired: z.boolean().optional(),
        secret: z.string().optional(),
        otpauthUrl: z.string().optional(),
    }),
]);
export const MfaVerifyRequestSchema = z.object({
    preAuthToken: z.string().min(1),
    code: z.string().regex(/^\d{6}$/),
});
//# sourceMappingURL=auth.js.map